import { useState, useEffect, useContext, useRef } from "react";
import { AppContext } from "../App";
import { processTimer } from "../CoreHelper";
import Arubastini from "../models/Arubastini";
import { MdPersonOutline, MdPerson } from 'react-icons/md';
import { GAME_TYPES } from "../Constants";

export default function View(props) {

  const app = useContext(AppContext);
  const [ type, setType ] = useState(props.type);
  const [ timer, setTimer ] = useState("--:--");
  const timerId = useRef(null);

  useEffect(() => {
    setType(props.type);

    if(timerId.current) {
      //clear the old timer
      clearInterval(timerId.current);
      timerId.current = setInterval(() => {
        setTimer(getTimer());
      }, 1000);
    } else {
      timerId.current = setInterval(() => {
        setTimer(getTimer());
      }, 1000);
    }

    return () => {
      if(timerId.current) {
        clearInterval(timerId.current)
      }
    }

  }, [ props.type, app.gameData, app.currentServerTimestamp ])

 

  
  function isCurrentPlayer() {
    if(type === 'player') {
      return (app.gameData && app.gameData.currentPlayer === app.gameData.playerId && app.gameData.status === 'ongoing')
    } else {
      return (app.gameData && app.gameData.currentPlayer === app.gameData.opponentId && app.gameData.status === 'ongoing')
    }
  }

  function getName() {
    if(type === 'player') {
      if(app.gameData && app.gameData.playerInfo) {
        return app.gameData.playerInfo.username
      }
    } else {
      if(app.gameData && app.gameData.opponentInfo) {
        return app.gameData.opponentInfo.username
      }
    }
  }

  function getTimer() {
    if(isCurrentPlayer() && app.gameData && app.gameData.status === 'ongoing') {
      return processTimer(app.gameData, app.currentServerTimestamp)
    } else {
      return "--:--";
    }
  }

  function getDeclaration() {
    //return <h6 className="font-bold text-center core-bg-goldish" style={{ fontSize: "14px", marginTop: "0px", paddingTop: "10px" }}>2 cards</h6>

    if(app.gameData) {
      if(app.gameData.type === GAME_TYPES.LASTCARD) {
        const cardDeclarations = JSON.parse(app.gameData.boardData).cardDeclarations;
        if(cardDeclarations && cardDeclarations.length > 0) {
          let _dec = null;
          let _userId = null;

          if(type === 'player') {
            _userId = app.gameData.playerId;
          } else {
            _userId = app.gameData.opponentId;
          }

          if(_userId) {
            cardDeclarations.forEach((item) => {
              if(item.userId === _userId) {
                _dec = {...item};
              }
            })
          }

          if(_dec) {
            if(_dec.type === 'normal') {
              if(_dec.cards.length > 1) {
                return <h6 className="font-semi-bold text-center core-bg-goldish" style={{ fontSize: "12px", marginTop: "-10px", paddingTop: "10px", marginRight: "-10px", marginLeft: "-10px" }}>{_dec.cards.length} <br/><span>Cards</span></h6>
              } else {
                return <h6 className="font-semi-bold text-center core-bg-goldish" style={{ fontSize: "12px", marginTop: "-10px", marginRight: "-10px", marginLeft: "-10px", paddingTop: "10px" }}>{_dec.cards.length} <br/><span>Card</span></h6>
              }
            } else if(_dec.type === 'special') {
              if(_dec.cards.length > 1) {
                return <h6 className="font-semi-bold text-center core-bg-goldish" style={{ fontSize: "12px", marginTop: "-10px", paddingTop: "10px", marginRight: "-10px", marginLeft: "-10px" }}>{_dec.cards.length} <br/><span>Special Cards</span></h6>
              } else {
                return <h6 className="font-semi-bold text-center core-bg-goldish" style={{ fontSize: "12px", marginTop: "-10px", paddingTop: "10px", marginRight: "-10px", marginLeft: "-10px" }}>{_dec.cards.length} <br/><span>Special Card</span></h6>
              }
            } else if(_dec.type === 'chimba') {
              return <h6 className="font-semi-bold text-center core-bg-goldish" style={{ fontSize: "12px", marginTop: "-10px", paddingTop: "10px", marginRight: "-10px", marginLeft: "-10px" }}>Pick Up<br/><span style={{ opacity: "0.7" }}>Chimba</span></h6>
            }
          }
        }
      }
    }

    return false;
  }

  return (
    <div 
      className={(type === 'player') ? 'coreCardsPlayerInfo text-start':'coreCardsPlayerInfo text-end'}
      data-type={type}
      data-is-current={isCurrentPlayer()}
    >
      {
        (isCurrentPlayer()) ?
        <>
          
          {
            (getDeclaration()) ?
            getDeclaration()
            :
            <MdPerson
              className="mPlayerIcon"
            />
          }
          <div className="core-bg-maronish" style={{ width: "100%", padding: "5px", borderRadius: "10px" }}>
            <h6 style={{ fontSize: "12px", margin: "0", textTransform: "capitalize" }} className="mOneLineText font-regular">{getName()}</h6>
          </div>
          <h6 className="text-center font-bold" style={{ fontSize: "14px" }}>{timer}</h6>
        </>
        :
        <>
          {
            (getDeclaration()) ?
            getDeclaration()
            :
            <MdPersonOutline
              className="mPlayerIcon"
            />
          }
          <div className="core-bg-bluish" style={{ width: "100%", padding: "5px", borderRadius: "10px" }}>
            <h6 style={{ fontSize: "12px", margin: "0", textTransform: "capitalize" }} className="mOneLineText font-regular">{getName()}</h6>
          </div>
          <h6 className="text-center font-bold" style={{ fontSize: "14px" }}>{timer}</h6>
        </>
      }
      

    </div>
  )
}